import { type FC, type ChangeEvent } from "react";
import { useFormContext } from "react-hook-form";
import * as styles from "./styles.css";

type Props = {
  name: string;
  placeholder: string;
  requiredMessage?: string;
  isError?: boolean;
  isDisabled?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  groupedList: {
    name: string;
    list: {
      key: string | number;
      value: string | number;
    }[];
  }[];
};

export const GroupedPulldown: FC<Props> = ({
  name,
  placeholder,
  requiredMessage,
  isError,
  isDisabled,
  onChange,
  groupedList,
}) => {
  const { register, clearErrors, watch } = useFormContext();
  const deleteErrorMessage = () => {
    clearErrors(name);
  };
  const isUnselected = watch(name);

  return (
    <select
      className={styles.pulldown({
        isUnselected: !!isUnselected,
        isError: !!isError,
      })}
      disabled={isDisabled}
      {...register(name, {
        required: requiredMessage,
        onChange: (e: ChangeEvent<HTMLInputElement>) => {
          if (onChange) onChange(e);
          deleteErrorMessage();
        },
      })}
    >
      <option value="">{placeholder}</option>
      {groupedList &&
        groupedList.length > 0 &&
        groupedList.map((group) => (
          <optgroup label={group.name} key={group.name}>
            {group.list.map((item) => (
              <option value={item.value} key={`${item.key}_${item.value}`}>
                {item.key}
              </option>
            ))}
          </optgroup>
        ))}
    </select>
  );
};
